import { MutationTree } from 'vuex'
import { FeatureFlagModuleState } from './feature-flags.model'

export enum MutationTypes {
  SET_FEATURE_FLAGS = 'SET_FEATURE_FLAGS'
}

export const mutations: MutationTree<FeatureFlagModuleState> = {
  [MutationTypes.SET_FEATURE_FLAGS](state, flags) {
    state.flags = flags
  }
}
